import { LayoutSidebarModeGenericProps } from "@/components/Layout/Sidebar/Mode/types";
import React from "react";

import Web3ClaimRewardsWrapper from "@/components/Web3/ClaimRewards/Wrapper";
import { twMerge } from "tailwind-merge";

export default function LayoutSidebarModeClaimRewards({ className, headerClassName }: LayoutSidebarModeGenericProps) {
  return (
    <div className={twMerge("relative flex h-full max-h-screen flex-col justify-start overflow-y-scroll p-6 pt-[60px]", className)}>
      <Web3ClaimRewardsWrapper headerClassName={headerClassName} />
    </div>
  );
}
